<div class="message-file">
  <div class="group">
    <div *ngFor="let file of message.content.files; trackBy: trackByFn" class="file">
      <div class="file__preview">
        <download-file-button [mode]="'icon'" [file]="file" [chatId]="message.chatId"></download-file-button>
      </div>

      <div class="file__data">
        <div class="file__name">{{ file.fileName }}</div>

        <div class="file__size">
          {{ file.size | fileSize }}
        </div>
      </div>
    </div>
  </div>

  <message-text *ngIf="message.content.text" [message]="message"></message-text>
</div>
